var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardContent, Typography, useTheme } from "@mui/material";
import { CardOverImageTitle, CardWithShadow, ShareArea } from "@nitra/nkmb-card-components/cards";
import { useIsMobileContext } from "@nitra/nkmb-card-components/contexts";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
/**
 * Card for displaying decade
 * Use forceMobile to force mobile view no matter the actual screen size, used in CMS
 * @param props
 * @constructor
 */
export function DecadeCard(props) {
    var _a;
    var forceMobile = props.forceMobile, isDoubleWidth = props.isDoubleWidth;
    var _b = props.data, title = _b.title, key = _b.key, subTitle = _b.subTitle, image288x360url = _b.image288x360url, image368x141url = _b.image368x141url;
    var _c = useState(forceMobile !== null && forceMobile !== void 0 ? forceMobile : false), useMobile = _c[0], setUseMobile = _c[1];
    var isMobile = useIsMobileContext();
    var isIos = useIosContext().isIos;
    var theme = useTheme();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    useEffect(function () {
        if (forceMobile !== undefined) {
            setUseMobile(forceMobile);
        }
        else {
            setUseMobile(isMobile);
        }
    }, [isMobile, forceMobile]);
    return (_jsxs(CardWithShadow, __assign({ fullSizeImageUrl: useMobile ? image368x141url : image288x360url, sx: {
            height: useMobile ? 144 : 360,
            display: "flex",
            flexDirection: "column",
            position: "relative",
        }, to: key, fixedWidth: useMobile ? undefined : isDoubleWidth ? 600 : 288 }, { children: [_jsxs(CardContent, __assign({ sx: { mt: "auto", zIndex: 1, mb: 2 } }, { children: [_jsx(CardOverImageTitle, { title: title, variant: useMobile ? "h4" : "podnaslovM", sx: (_a = {},
                            _a[theme.breakpoints.down("sm")] = isIos && {
                                '@media (-webkit-min-device-pixel-ratio: 2)': {
                                    fontWeight: 500, // Adjust font weight for iPhones
                                },
                            },
                            _a) }), subTitle &&
                        _jsx(Typography, __assign({ variant: "bodyS", sx: { zIndex: 1, color: "rgba(255,255,255,0.65)" } }, { children: getLocalizedString(subTitle, currentLang) }))] })), _jsx(ShareArea, { shareUrl: "/club/history/decades/".concat(key), brightText: true, sx: { position: "absolute", right: 16, bottom: 16, zIndex: 11 } })] })));
}
